import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/svg/optilynx.svg")